<template>
    <div class="bell-curve-container">
        <svg :width="width + margin*2" class="bell-curve-path" preserveAspectRatio="none">
            <g :transform="`translate(${margin},0)`">
                <defs>
                    <linearGradient id="g">
                        <stop offset="0%" stop-color="#00A883"/>
                        <stop :offset="`${value}%`" stop-color="#00A883"/>
                        <stop :offset="`${value}%`" stop-color="#AAA"/>
                        <stop offset="100%" stop-color="#AAA"/>
                    </linearGradient>
                </defs>
                <path class="path-xs" d="M0,490C230,490 290,10 400,10C500,10 560,490 790,490 0" fill="url(#g)"/>
                <path class="path-sm" d="M0,490C230,490 290,10 400,10C500,10 560,490 790,490 0" fill="url(#g)"/>
    <!-- 
                <line :x1="x(100)" :x2="x(100)" y1="0" :y2="width" stroke="#000"/>
                <line :x1="x(0)" :x2="x(0)" y1="0" :y2="width" stroke="#000"/> -->

                <line class="bell-curve__line bell-curve__line--xs" :x1="x(value)" :x2="x(value)" y1="0" :y2="210" stroke-width="2"/>
                <line class="bell-curve__line bell-curve__line--sm" :x1="x(value)" :x2="x(value)" y1="0" :y2="280" stroke-width="2"/>

                <text class="bell-curve__label bell-curve__label--xs" :x="x(value)" :y="225" text-anchor="middle">{{ label }}</text>
                <text class="bell-curve__label bell-curve__label--sm" :x="x(value)" :y="295" text-anchor="middle">{{ label }}</text>
            </g>
          <!-- <g v-axis="x" class="x-axis" :transform="`translate(0,${width-100})`"></g> -->
        </svg>
    </div>
</template>
<script>
import * as d3 from 'd3';

export default {
    name: 'bellCurveResult',
    props: {
        value: {
            type: Number
        },
        label: {
            type: String
        }
    },
    directives: {
        axis(el, binding) {
            d3.select(el).call(d3.axisBottom().scale(binding.value));
        }
    },
    data() {
        return {
            width: 0,
            margin: 20
        }
    },
    computed: {
        x() {
            return d3.scaleLinear().domain([0, 100]).range([0, this.width]);
        },
    },
    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.width = this.$el.parentElement.offsetWidth;
        },
    },
}
</script>
<style lang="scss">
.bell-curve-container {
    width: 250px;
}

.bell-curve-path {
    height: 260px;
    @media screen and (min-width: 576px) {
        height: 340px;
    }
}

.path-xs {
    transform: scale(0.385) translateX(-4px);
    @media screen and (min-width: 576px) {
        display: none;
    }
}

.path-sm {
    transform: scale(0.5125) translateX(-4px);
    @media screen and (max-width: 575px) {
        display: none;
    }
}

.bell-curve__line {
    fill: $main-font;
    stroke: $main-font;
    &--xs {
        @media screen and (min-width: 576px) {
            display: none;
        }
    }

    &--sm {
        @media screen and (max-width: 575px) {
            display: none;
        }
    }
}

.bell-curve__label {
    fill: $bq-green;
    font-size: 0.9rem;
    font-weight: bold;
    @media screen and (min-width: 576px) {
        font-size: 1.125rem;
    }

    &--xs {
        @media screen and (min-width: 576px) {
            display: none;
        }
    }

    &--xm {
        @media screen and (max-width: 575px) {
            display: none;
        }
    }
}
</style>